import gql from 'graphql-tag';

const mutation = gql`
  mutation SendPhoneNumberVerificationCode($params: SendPhoneNumberVerificationCodeParams!) {
    sendPhoneNumberVerificationCode(params: $params)
  }
`;

export default mutation;
